import * as Config from '../../config';
import { default as Locale } from '../../utils/Locale';
import * as UUID from '../../utils/Uuid';
import { AlertInfo, AlertType, AlertRecord, AlertCategories } from "../Types";
import { AlertLogic } from './AlertLogic';
import { ContentCategories } from "../../types";
import * as CommonText from "../../utils/common-text";

export class AmbientTempIssue extends AlertLogic {
    static type = AlertType.AmbientTempError;
    static category = AlertCategories.EQUIPMENT_FAILURE;
    static contentCategories = [ ContentCategories.EQUIPMENT_FAILURE ];
    static title:String = Locale.gettext('Ambient Temperature Issue');

    getInfo(alert:AlertRecord = this.alert, config:Config.AllConfig = this.allConfigs):AlertInfo {
        // Varying across alert types
        let cardIllustration = 'report_frightened';
        let detailIcon = 'temperature-sensor';
        let detailDescription = '';

        if (config?.Config?.Ambient?.Temperature) {
            detailDescription = this.locale.gettext("The ambient temperature sensor is not available and the current internet weather data is also not available.");
        } else {
            detailDescription = this.locale.gettext("The Attendant does not have a ambient temperature sensor configured and current internet weather data is also not available.");
        }

        const alertInfo = AlertInfo.fromCardConfig({
            cardTitle: this.locale.gettext('Temperature Problem'),
            cardDescription: this.locale.gettext('No sensor or weather data.'),
            cardIllustration: cardIllustration,
            detailTitle: this.locale.gettext('Ambient Temperature Problem'),
            detailIcon: detailIcon,
            detailDescriptionArr: [
                detailDescription,
                this.locale.gettext("Internet weather data should automatically download within the next hour and this message will clear."),
                CommonText.pleaseCallPoolsideSupportContact,
            ],
            resolveSummary: this.locale.gettext('Temperature information available again')
        });
        alertInfo.contentCategories = AmbientTempIssue.contentCategories;
        return alertInfo;
    } 

    static mock(type:AlertType, config:Config.AllConfig):AlertRecord {
        let device = config?.Config?.Devices?.find(dev => dev.DeviceType === "Thermistor");
        
        return device ? new AlertRecord({
            id: Math.floor(Math.random() * 100000),
            uuid: UUID.modifySection(4, UUID.modifySection(3, device.UUID, "MOCK"), "ALRT" + type),
            siteId: Math.floor(Math.random() * 100000),
            entityUuid: device.UUID,
            bodyUuid: config?.Config?.BodiesOfWater && config.Config.BodiesOfWater[ 0 ]?.UUID,
            type: type,
            data: {
                
            }
        }) : null;
    }
}